import { ExportBehavior } from '../../enums/file-writer/export-behavior';
import { FileLineEnd } from '../../enums/file-writer/file-line-end';
import { WriteMode } from '../../enums/file-writer/write-mode';
import { UniqueSettingsConfig } from '../unique-history/unique-settings-config';

/**
 * Base configuration shared by all file writer types (CSV, XML, JSON).
 * Provides the output file name, write behaviour, line endings, and duplicate export detection.
 */
export abstract class FileWriterBase {
	/** Output file name (with extension). Supports expression syntax for dynamic names. @default '' */
	fileName = '';
	/** How to handle an existing file with the same name. OverwriteExistingFile=0, ErrorOnExistingFile=1. @default WriteMode.OverwriteExistingFile */
	writeMode = WriteMode.OverwriteExistingFile;
	/** Line ending format. CRLF=0, LF=1. @default FileLineEnd.CRLF */
	lineEnd = FileLineEnd.CRLF;
	/** Whether to write all records into one file or one file per record. AllRecordsIntoOneFile=0, OneRecordPerFile=1. @default ExportBehavior.AllRecordsIntoOneFile */
	exportBehavior = ExportBehavior.AllRecordsIntoOneFile;
	/** Duplicate export detection settings. Throws if the same fileName has already been exported. */
	uniqueness: UniqueSettingsConfig = new UniqueSettingsConfig();

	constructor(init?: Partial<FileWriterBase>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
